import React from 'react';
import { useDriverInfo } from '../../hooks/useDriverInfo';
import DriverTrust from './DriverTrust';
import { computeBadge, BADGE_CONFIG } from '../../utils/driverBadge';
import { COLORS, FONTS } from '../../styles/tokens';

const initialsOf = name => (name ?? '').split(/\s+/).filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join('') || '?';

export default function DriverInfoCard({ driverUid }) {
  const { name, orgName, phone, tippiVerified, documented, languages, loading } = useDriverInfo(driverUid);

  const badgeKey  = computeBadge({ completedOrders: 0, cancellationTimestamps: [], tippiVerified: tippiVerified === true });
  const badgeInfo = BADGE_CONFIG[badgeKey];

  if (loading) {
    return (
      <div style={styles.card}>
        <div style={styles.avatar} />
        <div style={{ flex: 1 }}>
          <div style={{ ...styles.skeleton, width: 140, marginBottom: 8 }} />
          <div style={{ ...styles.skeleton, width: 100 }} />
        </div>
      </div>
    );
  }

  return (
    <div style={styles.card}>
      <div style={styles.avatar} aria-hidden="true">{initialsOf(name)}</div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={styles.label}>Sjåfør</div>
        <div style={styles.name}>{name || '—'}</div>
        <div style={styles.sub}>
          <span style={styles.badge}>{badgeInfo.label}</span>
          <DriverTrust documented={documented} languages={languages} />
          {orgName && <span style={styles.org}>{orgName}</span>}
        </div>
      </div>
      {phone && (
        <a href={`tel:${phone}`} style={styles.callBtn} aria-label="Ring sjåfør">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={COLORS.accent} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z" />
          </svg>
        </a>
      )}
    </div>
  );
}

const styles = {
  card: {
    display: 'flex', alignItems: 'center', gap: 12,
    background: COLORS.white, border: `1px solid ${COLORS.border}`,
    borderRadius: 18, padding: 12, marginBottom: 16,
  },
  avatar: {
    width: 44, height: 44, borderRadius: '50%', flexShrink: 0,
    background: COLORS.brandPanel, color: COLORS.accent,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: FONTS.display, fontWeight: 700, fontSize: 19,
  },
  label: { fontSize: 11, color: COLORS.textLight },
  name: { fontSize: 15.5, fontWeight: 700, color: COLORS.textDark },
  sub: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginTop: 2 },
  badge: { background: COLORS.surfaceHover, color: COLORS.textDark, borderRadius: 20, padding: '2px 8px', fontSize: 10.5, fontWeight: 700 },
  org: { fontSize: 12.5, color: COLORS.textMid },
  callBtn: {
    width: 44, height: 44, borderRadius: '50%', flexShrink: 0,
    background: COLORS.brandPanel, display: 'flex', alignItems: 'center', justifyContent: 'center',
    textDecoration: 'none',
  },
  skeleton: {
    height: 14, background: COLORS.skeleton, borderRadius: 4,
    animation: 'skeleton-pulse 1.2s ease-in-out infinite',
  },
};
